import apiServices from '../../ApiServices/request-handler';
import { downloadBase64File, requestHandler } from '../../utils/functions';
import { setInvestmentStatement, setInvestmentLoading, setInvestmentDetails, setClientHoldings } from '../slices/fund-investment-slice';

export const getInvestmentStatement = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setInvestmentLoading,
        apiService: apiServices.getInvestmentStatement,
        param_data: params,
        onDone: (val) => dispatch(setInvestmentStatement(val?.result?.data)),
      }),
    );
};
export const getInvestmentDetails = () => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setInvestmentLoading,
        apiService: apiServices.getInvestmentDetails,
        setData: setInvestmentDetails,
      }),
    );
};
export const getClientHoldings = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setInvestmentLoading,
        apiService: apiServices.getClientHoldings,
        param_data: params,
        setData: setClientHoldings,
      }),
    );
};
export const downloadInvestmentReport = (params) => {
  return async (dispatch) =>
    dispatch(
      requestHandler({
        setLoading: setInvestmentLoading,
        apiService: apiServices.downloadInvestmentReport,
        param_data: params,
        onDone: (val) =>
          downloadBase64File({
            base64Data: val?.result?.fileData,
            fileName: val?.result?.fileName,
          }),
      }),
    );
};
